module.exports = __webpack_public_path__ + "img/kx5.aa9fb12e.png";